/** 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR) */

import type { SupportedLanguage } from '../../utils/language.utils';

export type ActivitySourceView = {
  channel?: 'UI' | 'INTERNAL_SERVICE' | 'EXTERNAL_API';
  entryApplicationCode?: string;
  callerApplicationCode?: string | null;
  workKind?: 'HUMAN' | 'SERVICE' | 'AI';
  effectiveUserId?: string | null;
  initiatingUserId?: string | null;
  aiWorkId?: string | null;
  integration?: { principalName?: string; credentialName?: string | null; keyId?: string; credentialId?: string } | null;
};

const copy: Record<SupportedLanguage, { source: string; detail: string; ui: string; internal: string; ai: string; api: string; unknown: string; credential: string }> = {
  tr: { source: 'Kaynak', detail: 'Ayrıntı', ui: 'Arayüz', internal: 'İç servis', ai: 'AI çalışması', api: 'API', unknown: 'Bilinmiyor', credential: 'API anahtarı' },
  en: { source: 'Source', detail: 'Detail', ui: 'Interface', internal: 'Internal service', ai: 'AI work', api: 'API', unknown: 'Unknown', credential: 'API key' },
  de: { source: 'Quelle', detail: 'Details', ui: 'Oberfläche', internal: 'Interner Dienst', ai: 'KI-Arbeit', api: 'API', unknown: 'Unbekannt', credential: 'API-Schlüssel' },
  fr: { source: 'Source', detail: 'Détail', ui: 'Interface', internal: 'Service interne', ai: 'Travail IA', api: 'API', unknown: 'Inconnu', credential: 'Clé API' },
  es: { source: 'Origen', detail: 'Detalle', ui: 'Interfaz', internal: 'Servicio interno', ai: 'Trabajo de IA', api: 'API', unknown: 'Desconocido', credential: 'Clave API' },
  it: { source: 'Origine', detail: 'Dettaglio', ui: 'Interfaccia', internal: 'Servizio interno', ai: 'Lavoro IA', api: 'API', unknown: 'Sconosciuto', credential: 'Chiave API' },
  ar: { source: 'المصدر', detail: 'التفاصيل', ui: 'الواجهة', internal: 'خدمة داخلية', ai: 'عمل الذكاء الاصطناعي', api: 'API', unknown: 'غير معروف', credential: 'مفتاح API' },
  ru: { source: 'Источник', detail: 'Подробности', ui: 'Интерфейс', internal: 'Внутренняя служба', ai: 'Работа ИИ', api: 'API', unknown: 'Неизвестно', credential: 'Ключ API' },
  zh: { source: '来源', detail: '详情', ui: '界面', internal: '内部服务', ai: 'AI 工作', api: 'API', unknown: '未知', credential: 'API 密钥' },
  ja: { source: '発生元', detail: '詳細', ui: '画面', internal: '内部サービス', ai: 'AI 作業', api: 'API', unknown: '不明', credential: 'API キー' },
};

export function activitySourceLabels(language: SupportedLanguage) { return copy[language] ?? copy.en; }

export function activitySourceDisplay(
  source: ActivitySourceView | null | undefined,
  targetApplicationCode: string | null | undefined,
  language: SupportedLanguage,
): { source: string; detail: string; title: string } {
  const labels = activitySourceLabels(language);
  if (!source) return { source: targetApplicationCode || labels.unknown, detail: labels.unknown, title: labels.unknown };
  const entry = source.channel === 'EXTERNAL_API' ? labels.api : source.entryApplicationCode || targetApplicationCode || labels.unknown;
  const detail = source.channel === 'EXTERNAL_API'
    ? source.integration?.principalName || labels.unknown
    : source.workKind === 'AI' ? labels.ai : source.channel === 'UI' ? labels.ui : labels.internal;
  const key = source.integration?.credentialName;
  return { source: entry, detail, title: key ? `${detail} · ${labels.credential}: ${key}` : detail };
}
